import { ChevronDown, Zap } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { PROVIDER_META, findModel, modelsForKind } from "@/lib/meta";

export const ModelSwitcher = ({ catalog, category, provider, model, onSwitch, disabled }) => {
  const meta = PROVIDER_META[provider];
  const Icon = meta.icon;
  const current = findModel(catalog, provider, model);
  const recommended = new Set((category?.recommendations || []).map((r) => `${r.provider}/${r.model}`));
  const kind = category?.kind || "text";
  const providers = catalog.providers.map((p) => ({ ...p, models: modelsForKind(p, kind) })).filter((p) => p.models.length > 0);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild disabled={disabled}>
        <button data-testid="model-switcher-btn" className={`flex items-center gap-2 pl-3 pr-2.5 py-1.5 rounded-xl border text-sm transition-colors disabled:opacity-60 ${meta.badge} hover:brightness-125`}>
          <Icon className="w-4 h-4" />
          <span className="font-medium">{current?.name || model}</span>
          <ChevronDown className="w-3.5 h-3.5 opacity-70" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-72 bg-[#11131E] border-slate-800 text-slate-200 max-h-[70vh] overflow-y-auto" data-testid="model-switcher-menu">
        {providers.map((p, i) => {
          const pm = PROVIDER_META[p.id];
          const PIcon = pm.icon;
          return (
            <div key={p.id}>
              {i > 0 && <DropdownMenuSeparator className="bg-slate-800" />}
              <DropdownMenuLabel className={`flex items-center gap-2 text-xs uppercase tracking-widest ${pm.color}`}><PIcon className="w-3.5 h-3.5" /> {p.name}</DropdownMenuLabel>
              {p.models.map((m) => {
                const active = p.id === provider && m.id === model;
                const rec = recommended.has(`${p.id}/${m.id}`);
                return (
                  <DropdownMenuItem key={m.id} data-testid={`switch-model-${m.id}`} onClick={() => !active && onSwitch(p.id, m.id)}
                    className={`cursor-pointer focus:bg-[#1F2338] focus:text-white flex items-center justify-between ${active ? "bg-indigo-500/10 text-indigo-200" : ""}`}>
                    <div>
                      <p className="text-sm">{m.name}</p>
                      <p className="text-[11px] text-slate-500">{m.tag}</p>
                    </div>
                    {rec && <Zap className="w-3.5 h-3.5 text-indigo-400 shrink-0" />}
                  </DropdownMenuItem>
                );
              })}
            </div>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
